import React from 'react';
import ReactMarkdown from 'react-markdown';
import { StepAnimator } from './StepAnimator';

interface LessonContent {
    markdown: string;
    steps?: {
        title: string;
        description: string;
        imageUrl: string;
    }[];
}

interface LearnLessonProps {
    content: LessonContent;
}

export const LearnLesson: React.FC<LearnLessonProps> = ({ content }) => {
    return (
        <div className="prose prose-sm dark:prose-invert max-w-none">
            <ReactMarkdown>
                {content.markdown || ''}
            </ReactMarkdown>

            {content.steps && content.steps.length > 0 && (
                <div className="my-8 not-prose">
                    <h5 className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2 flex items-center gap-2">
                        <span className="w-8 h-[1px] bg-slate-200 dark:bg-slate-700"></span>
                        Visual Walkthrough
                        <span className="flex-1 h-[1px] bg-slate-200 dark:bg-slate-700"></span>
                    </h5>
                    <StepAnimator steps={content.steps} />
                </div>
            )}
        </div>
    );
};
